<template>
  <v-dialog v-model="opened" persistent width="700px">
    <v-card>
      <v-card-title>
        {{ $t("activities.edit.schedule.title") }}
      </v-card-title>
      <v-card-text>
        <v-btn
          :disabled="!shortSchedule || shortSchedule.length === 1 || !started"
          color="error"
          class="mr-2"
          @click="triggerNextScheduleEntry"
        >
          <v-icon left> mdi-skip-next </v-icon>
          {{ $t("activities.edit.schedule.triggerNextScheduleEntry") }}
        </v-btn>
        <v-btn
          :disabled="!shortSchedule || shortSchedule.length === 1 || !started"
          color="primary"
          @click="postponeOneMinute"
        >
          <v-icon left> mdi-timer-sand-full </v-icon>
          {{ $t("activities.edit.schedule.postponeOneMinute") }}
        </v-btn>

        <template v-for="(schedule, index) in parsedSchedule">
          <v-divider v-if="index !== 0" :key="`${index}-divider`" />
          <v-list-item
            :key="index"
            :class="{
              'pl-0': true,
              'ended-schedule': isPastScheduleEntry(schedule),
            }"
            dense
          >
            <span class="mr-4 text-right" style="min-width: 40px">{{ schedule.startMoment.format("HH:mm:ss") }}</span>
            <v-list-item-content class="py-0">
              {{ schedule.title }}
            </v-list-item-content>
            <v-list-item-action>
              <div v-if="schedule.id === currentScheduleEntry().id && currentScheduleTimeLeft >= 0">
                {{ currentScheduleTimeLeft }} {{ $t("activities.edit.schedule.seconds") }}
              </div>
            </v-list-item-action>
            <v-list-item-action class="my-0">
              <div v-if="schedule.id === currentScheduleEntry().id" class="d-flex">
                <v-icon class="mx-3">mdi-autorenew mdi-spin </v-icon>
              </div>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-card-text>
      <v-card-actions class="list-footer-sticky">
        <v-spacer></v-spacer>
        <v-btn color="secondary" outlined @click.prevent="close()">
          {{ $t("activities.edit.schedule.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "ActivitiesEditScheduleModal",
  data() {
    return {
      opened: false,
      activity: {},
    };
  },
  methods: {
    open(activity) {
      this.activity = activity;
      this.opened = true;
    },
    close() {
      this.opened = false;
      this.activity = null;
    },
    async triggerNextScheduleEntry() {
      let currentEntryTimeLeftMilliseconds =
        this.currentParsedScheduleEntry.endDur.asMilliseconds() - this.elapsedTime.asMilliseconds();
      let triggerNextResponse = await axios.post(`/admin/activities/${this.activity.id}/triggerNextScheduleEntry`, {
        currentScheduleActivityId: this.currentScheduleEntry().id,
        currentEntryTimeLeftMilliseconds,
      });

      let scheduleActivity = this.activity.schedule.find(
        (entry) => entry.id === triggerNextResponse.currentScheduleActivityId
      );
      scheduleActivity.durationSeconds = triggerNextResponse.durationSeconds;
    },
    async postponeOneMinute() {
      let postponeResponse = await axios.post(`/admin/activities/${this.activity.id}/postponeNextScheduleEntry`, {
        currentScheduleActivityId: this.currentScheduleEntry().id,
        seconds: 60,
      });

      let scheduleActivity = this.activity.schedule.find(
        (entry) => entry.id === postponeResponse.currentScheduleActivityId
      );
      scheduleActivity.durationSeconds = postponeResponse.durationSeconds;
    },
    isPastScheduleEntry(entry) {
      if (this.elapsedTime) {
        return this.elapsedTime.asMilliseconds() > entry.endDur.asMilliseconds();
      }
    },
    currentScheduleEntry() {
      return this.shortSchedule && this.shortSchedule.length ? this.shortSchedule[0] : {};
    },
  },
  async mounted() {
    await this.$store.dispatch("LOAD_SERVER_TIME");
  },
  computed: {
    currentScheduleTimeLeft() {
      return Math.round(
        (this.currentParsedScheduleEntry.endDur.asMilliseconds() - this.elapsedTime.asMilliseconds()) / 1000
      );
    },
    elapsedTime() {
      if (!this.activity.date || !this.$store.state.serverTime) {
        return null;
      }
      return moment.duration(this.$store.state.serverTime.diff(moment(this.activity.date)));
    },

    started() {
      return this.elapsedTime >= 0;
    },
    parsedSchedule() {
      if (!this.activity || !this.activity.schedule) return null;
      const startDur = moment.duration();
      return this.activity.schedule.map((item) => {
        const st = moment.duration(startDur);
        startDur.add(item.durationSeconds, "s");
        return {
          ...item,
          startDur: st,
          endDur: moment.duration(startDur),
          startMoment: moment(this.activity.date).add(st),
        };
      });
    },
    shortSchedule() {
      return (
        this.parsedSchedule &&
        this.parsedSchedule
          .filter((s, i) => !this.isPastScheduleEntry(s) || i === this.parsedSchedule.length - 1)
          .slice(0, 2)
      );
    },
    currentParsedScheduleEntry() {
      return this.parsedSchedule.find((i) => this.shortSchedule[0].id === i.id);
    },
  },
};
</script>

<style scoped></style>
